module.exports = __webpack_public_path__ + "static/img/acq-form-5.0a9d514.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/acq-form-5.png
// module id = LTSc
// module chunks = 1